import React, { useState } from 'react';
import { CustomPicker } from 'react-color';
import reactCSS, { hover } from 'reactcss';

type IProps = {
  colors: any;
  selected: any;
  onSelect: any;
};

const BasicColorPicker = ({ colors, selected, onSelect }: IProps) => {
  const [currentColor, setCurrentColor] = useState(selected);

  return (
    <div className="flex flex-row flex-wrap">
      {colors.map((color: any, idx: any) => {
        const styles = reactCSS({
          default: {
            colorSwatch: {
              height: '40px',
              width: '60px',
              cursor: 'pointer',
              backgroundColor: color,
            },
            colorSwatchSelected: {
              height: '40px',
              width: '60px',
              cursor: 'pointer',
              backgroundColor: color,
              boxShadow: `0 0 5px ${color}`,
            },
            colorSwatchIcon: {
              color: 'white',
              width: '30px',
              height: '30px',
              margin: '5px 15px',
            },
          },
        });

        return (
          <div
            onClick={() => {
              setCurrentColor(color);
              onSelect(color);
            }}
            style={
              currentColor === color
                ? styles.colorSwatchSelected
                : styles.colorSwatch
            }
            className="mr-4 mb-4"
          >
            <svg
              className={`${currentColor !== color && 'hidden'}`}
              style={styles.colorSwatchIcon}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        );
      })}
    </div>
  );
};

export default CustomPicker(hover(BasicColorPicker));
